<template>
  <div>
    <section class="content-header">
      <h1>{{ $t('contact_type.edit', {entity: retrieved && retrieved.name}) }}</h1>
    </section>

    <section class="content">
      <div class="box box-primary">
        <div class="box-body">
          <item-update-errors :entity="'contact_type'" :is-loading="isLoading"></item-update-errors>

          <ContactTypeForm
            v-if="item && !isLoading"
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :values="item"
            :errors="violations"
            :initial-values="retrieved" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContactTypeForm from './Form.vue'
import ItemUpdateErrors from '../layout/errors/ItemUpdateErrors'

export default {
  components: {
    ItemUpdateErrors,
    ContactTypeForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'contact_type/update/isLoading',
      deleted: 'contact_type/del/deleted',
      retrieved: 'contact_type/update/retrieved',
      violations: 'contact_type/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'ContactTypeList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'contact_type/create/reset',
      delReset: 'contact_type/del/reset',
      retrieve: 'contact_type/update/retrieve',
      updateReset: 'contact_type/update/reset',
      update: 'contact_type/update/update',
      updateRetrieved: 'contact_type/update/updateRetrieved'
    }),

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update().then(item => {
        this.$router.push({name: 'ContactTypeShow', params: {id: item['@id']}})
      }).catch(e => {})
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contact_type/Update.vue